export enum ProfileType {
    God = 1,
    Company,
    Brand
}
